import React from 'react';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
import { Section, CTAButton } from './Shared';
export const EmotionalClose = () => {
  return <Section className="max-w-5xl" data-id="element-34">
      <div className="glass-panel p-6 md:p-12 rounded-3xl text-center bg-white/90 border-brand-gold/30 shadow-lg relative overflow-hidden" data-id="element-35">
        <div className="absolute top-0 left-0 w-24 h-24 bg-brand-gold/10 rounded-br-full -z-10" data-id="element-36"></div>
        <div className="absolute bottom-0 right-0 w-24 h-24 bg-brand-goldDark/10 rounded-tl-full -z-10" data-id="element-37"></div>

        <h2 className="text-2xl md:text-4xl font-display font-bold mb-8 text-brand-darkGreen leading-tight" data-id="element-38">
          ⚖️ LA DECISIÓN ES TUYA
        </h2>

        <div className="space-y-5 text-base md:text-lg text-brand-text mb-10 max-w-2xl mx-auto" data-id="element-39">
          <p data-id="element-40">
            En este momento existen dos versiones de vos. La primera cierra esta
            página. Y sigue haciendo exactamente lo mismo que hasta ahora.
            Comprando velas que no sabe cómo usar. Gastando en santerías sin
            resultados. Esperando que la situación mejore sola.
          </p>

          <p className="font-medium text-brand-goldDark" data-id="element-41">
            Y después está la segunda versión. La que entiende que el problema
            no es la crisis económica del país. La que entiende que no necesita
            más productos caros ni rituales complicados. La que entiende que
            primero necesita limpiar lo que está bloqueando el flujo de dinero
            en su propia casa.
          </p>
          <p className="font-serif italic text-lg md:text-xl text-brand-darkGreen" data-id="element-42">
            Porque la realidad es simple: Podés trabajar todo lo que quieras.
            Pero si tu casa tiene bloqueos energéticos activos... el dinero va a
            seguir escapándose por las grietas invisibles.
          </p>
        </div>

        <h3 className="text-xl md:text-3xl font-display font-bold mb-8 text-brand-darkGreen" data-id="element-43">
          ¿CON CUÁL EMPEZÁS?
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-10" data-id="element-44">
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-brand-gold/30 bg-white/85 text-center flex flex-col" data-id="element-45">
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-darkGreen mb-1" data-id="element-46">
              📘 KIT ESENCIAL
            </h4>
            <div className="text-xl md:text-2xl font-bold text-brand-darkGreen mb-3" data-id="element-47">
              $19.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-48">
              Ideal para quien necesita limpiar su energía, frenar la mala racha
              y proteger su hogar de forma urgente.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href="https://www.lumenakasha.com/cart/47029498773693:1" variant="gold" data-id="element-49">
              📘 → LO QUIERO $19.990
            </CTAButton>
          </div>

          <div className="glass-panel rounded-2xl p-6 md:p-7 border-2 border-brand-goldDark bg-white/95 text-center flex flex-col relative shadow-[0_10px_30px_rgba(212,175,55,0.18)]" data-id="element-50">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-goldDark text-white text-[10px] md:text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap" data-id="element-51">
              ⭐ MÁS ELEGIDO
            </div>
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-goldDark mb-1 mt-2" data-id="element-52">
              ⭐ KIT AVANZADO
            </h4>
            <div className="text-xl md:text-2xl font-bold text-brand-goldDark mb-3" data-id="element-53">
              $27.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-54">
              Ideal para quien quiere limpiar, proteger y además reprogramar su
              relación con el dinero en el día a día.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href="https://www.lumenakasha.com/cart/47029498839229:1" variant="green" data-id="element-55">
              ⭐ → LO QUIERO $27.990
            </CTAButton>
          </div>

          <div className="glass-panel rounded-2xl p-6 md:p-7 border-brand-gold/30 bg-white/85 text-center flex flex-col" data-id="element-56">
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-darkGreen mb-1" data-id="element-57">
              🌟 COMBO DE ORO
            </h4>
            <div className="text-xl md:text-2xl font-bold text-brand-darkGreen mb-3" data-id="element-58">
              $34.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-59">
              Ideal para quien no quiere dejar nada al azar y quiere pasar de
              sobrevivir a expandir su economía de forma masiva.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href="https://www.lumenakasha.com/cart/47029499363517:1" variant="gold" data-id="element-60">
              🌟 → LO QUIERO $34.990
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mb-8" data-id="element-61">
          <div className="flex items-center" data-id="element-62">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-63" /> Pago 100%
            seguro
          </div>
          <div className="flex items-center" data-id="element-64">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-65" /> Descarga
            inmediata
          </div>
          <div className="flex items-center" data-id="element-66">
            <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-67" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-68">
            <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-69" /> Mercado
            Pago
          </div>
        </div>

        <div className="text-sm text-brand-text bg-brand-surfaceLight/60 p-5 md:p-6 rounded-2xl border border-brand-gold/20 space-y-3 text-left md:text-center" data-id="element-70">
          <p data-id="element-71">
            P.D.: Tu casa no está maldita. Está bloqueada. Y eso tiene solución.
            Pero solo si decidís actuar hoy.
          </p>
        </div>
      </div>
    </Section>;
};